const PATHS = {
  auth: {
    login: "/auth/login",
    register: "/auth/register",
    forgot: "/auth/forgot",
    changePassword: "/auth/change-password",
  },
  home: "/",
  settings: "/settings",
  explore: "/explore-collection",
  profile: "/profile",
  editProfile: "/edit-profile",
  subscriptionPlans: "/subscription-plans",
  orderSummary: "/order-summary",
  payments: "/payments",
  addNewCard: "/add-new-card",
  editCard: "/edit-card",
  createCollection: "/create-collection",
  uploadNft: "/upload-nft",
  subscription: "/subscription",
  terms: "/terms",
  privacy: "/privacy",
  contact: "/contact",
  about: "/about",
};

export { PATHS };
